<template>
  <div class="table-responsive bg-utel-v2-secondary p-3 mb-2 mt-4 mx-lg-5 mx-md-2 mx-sm-2 rounded-8">
    <table class="table table-borderless text-table-normal">
      <thead>
        <tr>
          <th><strong>Nombre</strong></th>
          <th><strong>Correo</strong></th>
          <th><strong>Celular</strong></th>
          <th><strong>Cargo</strong></th>
          <th><strong>Área</strong></th>
          <th><strong>Nivel</strong></th>
          <th rowspan="2" class="align-middle text-center">
            <button 
              class="btn bg-white sin-borde text-primary rounded-8" 
              @click="$emit('edit')"
            >
              Editar información
            </button>
          </th>
          <th rowspan="2" class="align-middle text-center">
            <button 
              class="btn bg-white sin-borde text-primary rounded-8" 
              @click="$emit('delete')"
            >
              Eliminar usuario
            </button>
          </th>
        </tr>
        <tr>
          <td>{{ fullName }}</td>
          <td>{{ student.email }}</td>
          <td>{{ student.cellphone || '-' }}</td>
          <td>{{ student.position || '-' }}</td>
          <td>{{ student.area || '-' }}</td>
          <td>{{ student.level || '-' }}</td>
        </tr>
      </thead>
    </table>
  </div>
</template>

<script>
export default {
  name: 'StudentInfoCard',
  
  props: {
    student: { type: Object, required: true }
  },

  emits: ['edit', 'delete'],

  computed: {
    fullName() {
      return `${this.student.firstname || ''} ${this.student.lastname || ''}`.trim()
    }
  }
}
</script>

<style scoped>
.text-table-normal {
  font-size: 12px;
  color: #1A0054;
}
</style>